import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import Radio, { OwnFieldProps as RadioProps } from './Radio';

const RadioField = (props: RadioProps & WrappedFieldProps) => {
  const { input, meta, hideErrors, ...selectProps } = props;

  const errorMessage = !hideErrors && meta && meta.touched && meta.error ? meta.error : null;

  return (
    <Radio
      value={input.value}
      onChange={input.onChange}
      name={input.name}
      {...selectProps}
      errorMessage={errorMessage}
    />
  );
};

const ComposedRadioField = React.memo(RadioField);

export default ComposedRadioField;
